import React from "react";

const Pagination = ({ pageNumbers, currentPage, handleClick }) => {
    if (pageNumbers.length <= 1) return null;

    return (
        <div className="flex justify-center items-center gap-2 mt-10">
            {pageNumbers.map(number => (
                <button
                    key={number}
                    onClick={(event) => handleClick(event, number)}
                    className={`w-9 h-9 rounded-lg text-sm font-medium transition-colors duration-200 ${
                        number === currentPage
                            ? 'bg-warm-600 text-white'
                            : 'bg-white text-warm-600 border border-warm-200 hover:bg-warm-100'
                    }`}
                >
                    {number}
                </button>
            ))}
        </div>
    );
};

export default Pagination;
